import {
  coverageListResponse,
  createCoveragePayload,
  updateCoveragePayload,
} from 'interfaces/Coverage';
import api from 'services';

const path = '/coverage';

// Listar coberturas
export const getCoverageList = async (): Promise<coverageListResponse> => {
  const response = await api.get<coverageListResponse>(`${path}/list`);
  return response.data;
};

// Buscar cobertura por ID
export const getCoverageById = async (id: number): Promise<coverageListResponse> => {
  const response = await api.get<coverageListResponse>(`${path}/${id}`);
  return response.data;
};

// Criar cobertura
export const createCoverage = async (payload: createCoveragePayload): Promise<coverageListResponse> => {
  const response = await api.post<coverageListResponse>(`${path}/`, payload);
  return response.data;
};

// Atualizar cobertura
export const updateCoverage = async (payload: updateCoveragePayload): Promise<coverageListResponse> => {
  const { id, ...data } = payload;
  const response = await api.put<coverageListResponse>(`${path}/${id}`, data);
  return response.data;
};

// Deletar cobertura
export const deleteCoverage = async (id: number): Promise<void> => {
  await api.delete(`${path}/${id}`);
};
